import * as Acciones  from './reduce.actions';

export interface RegistroClienteState {
     registroCliente: any;
}

export const initialState = {
    registroCliente: { }
};

export function reducerCliente(state: RegistroClienteState = initialState, action: Acciones.actions) {
    switch (action.type) {
        case Acciones.REGISTRAR_CLIENTE:
            return {
                ...state,
                registroCliente: action.registroCliente
            }
        default:
            return state;
    }
}
